


































































































import {
  defineComponent, computed, watch, reactive,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import ViewOnlyGuard from '@/components/ViewOnlyGuard.vue';

import getUser from '@/gql/getUser.gql';
import createUser from '@/gql/createUser.gql';
import updateUser from '@/gql/updateUser.gql';
import changeUserRole from '@/gql/changeUserRole.gql';

const UserEditor = defineComponent({
  setup() {
    /* ==== Get meta data ==== */
    const { route } = useRouter();
    // eslint-disable-next-line
    const mode = route.value.meta.mode;
    // Try to destructor but doesn't work Q^Q
    const modeDisplay = computed(() => {
      if (mode === 'create') return 'เพิ่ม';
      if (mode === 'edit') return 'แก้ไข';
      if (mode === 'view') return 'ดู';
      return '';
    });
    // Try to destructor but doesn't work Q^Q

    const form = reactive({
      roles: '',
      role: '',
      firstName: '',
      lastName: '',
      employeeCode: '',
      username: '',
      password: '',
      confirmPassword: '',
    });

    // ===== Get value when enter edit mode ===== //
    const { result: userResult } = useQuery(getUser, computed(() => ({
      id: parseInt(route.value.params.userId, 10),
    })));
    watch(userResult, () => {
      const media = useResult(userResult, null, (data) => data.user);
      const item = media.value;
      form.firstName = item?.firstName;
      form.lastName = item?.lastName;
      form.employeeCode = item?.employeeCode || '';
      form.username = item?.username;
      form.password = item?.password;
      form.role = item?.roles[0]?.id || '4';
      form.roles = item?.roles[0]?.id || '4';
    });

    /* ===== Menu manager ===== */
    const editorMenu = [
      { id: 0, status: true, display: 'บัญชีเข้าใช้งาน' },
    ];

    function changeActiveMenu(index: number) {
      for (let i = 0; i < editorMenu.length; i += 1) {
        if (editorMenu[index].id === i) editorMenu[i].status = true;
        else editorMenu[i].status = false;
      }
    }
    // ===============================

    /* ==== Define role ==== */
    const roleList = [
      { id: 1, totalPeople: '1', name: 'Admin' },
      { id: 2, totalPeople: '2', name: 'Moderator' },
      { id: 3, totalPeople: '3', name: 'Recorder' },
      { id: 4, totalPeople: '4', name: 'Visitor' },
    ];
    const roleId: number[] = [];
    const roleName: string[] = [];
    roleList.forEach((role) => {
      roleId.push(role.id);
      roleName.push(role.name);
    });

    const userInput = computed(() => ({
      firstName: form.firstName,
      lastName: form.lastName,
      employeeCode: form.employeeCode,
      username: form.username,
      password: form.password,
    }));

    const createUserMutation = useMutation(
      createUser,
      () => ({
        variables: { ...userInput.value },
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );

    const changeUserRoleMutation = useMutation(
      changeUserRole,
      () => ({
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );

    const updateUserMutation = useMutation(
      updateUser,
      () => ({
        variables: {
          id: route.value.params.userId,
          ...userInput.value,
        },
        refetchQueries: ['getUsers', 'getRoles'],
      }),
    );

    createUserMutation.onDone((data) => {
      changeUserRoleMutation.mutate({
        id: data?.data.createUser.id,
        roleId: form.role,
      });
    });

    updateUserMutation.onDone((data) => {
      if (form.role !== form.roles) {
        changeUserRoleMutation.mutate({
          id: route.value.params.userId,
          roleId: form.role,
        });
      }
    });

    const computedMutation = computed(() => {
      if (mode === 'create') return createUserMutation;
      return updateUserMutation;
    });

    return {
      mode,
      modeDisplay,
      editorMenu,
      changeActiveMenu,
      roleId,
      roleName,
      form,
      computedMutation,
    };
  },
  components: {
    ViewOnlyGuard,
    CommonConfirmDialog,
  },
  props: {
    role: {},
  },
});

export default UserEditor;
